// extracted by mini-css-extract-plugin
export default {"file":"SendImages_file__Dqj+O","fileInner":"SendImages_fileInner__JukKU","fileLabel":"SendImages_fileLabel__dRSFi","fileButton":"SendImages_fileButton__-JoKm"};